import { createSlice } from '@reduxjs/toolkit';

const initialFilters = [
  {
    filterName: 'firstname',
    a_filter_type: '',
  },
  {
    filterName: 'email',
    a_filter_type: '',
  },
  {
    filterName: 'phone',
    a_filter_type: '',
  },
  {
    filterName: 'country',
    a_filter_type: '',
  },
  {
    filterName: 'currency',
    a_filter_type: '',
  },
  {
    filterName: 'credit',
    a_filter_type: '',
  },
  {
    filterName: 'status',
    a_filter_type: '',
  },
  {
    filterName: 'date',
    a_filter_type: '',
  },
];

const initialState = {
  filter: initialFilters,
  searchFilters: [],
};

export const filterSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filter = action.payload;
    },
    setSearchFilters: (state, action) => {
      state.searchFilters = action.payload;
    },
  },
});

export const { setFilters, setSearchFilters } = filterSlice.actions;
export default filterSlice.reducer;
